import script from "./ListItemBullet.vue?vue&type=script&lang=ts&setup=true"
export * from "./ListItemBullet.vue?vue&type=script&lang=ts&setup=true"

import "./ListItemBullet.vue?vue&type=style&index=0&id=ece61a18&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ece61a18"]])

export default __exports__